import React from "react";
import { Button } from "react-bootstrap";
import { setComponentFlag } from "presentation/utils/functions/generic";
import { FaTrashAlt } from "react-icons/fa";
import CancelButton from "presentation/components/buttons/cancel";


class InlineRemove extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            waitingFeedback: false
        };
    }

    toggleActionInterface = () => {
        this.setState({ waitingFeedback: !this.state.waitingFeedback });
    }

    render() {
        let { deleteIsDisabled, loading, optionId, removeAction, component, buttonSize } = this.props;
        let { waitingFeedback } = this.state;
        let { toggleActionInterface } = this;
        return (
            <div>
                {waitingFeedback === false && <Button
                    size={buttonSize}
                    disabled={loading}
                    variant={deleteIsDisabled ? 'secondary' : 'danger'}
                    className="float-end"

                    onClick={
                        () => deleteIsDisabled ? setComponentFlag(component, "deleteTip", true) : toggleActionInterface()}
                >
                    <FaTrashAlt />
                </Button>
                }
                {waitingFeedback === true && (
                    <div className="float-end">
                        <span>Quer mesmo remover? </span>
                        &nbsp;
                        <Button
                            size={buttonSize}
                            variant='success'
                            onClick={() => { toggleActionInterface(); removeAction(optionId); }}
                        >
                            Sim
                        </Button>
                        &nbsp;
                        <CancelButton
                            containerProps={{
                                size: buttonSize,
                                onClick: toggleActionInterface
                            }}
                        />
                    </div>
                )}
            </div>
        );
    };
}

export default InlineRemove;


